import { useTranslation } from "react-i18next";
import { useLocation, useNavigate } from "react-router-dom";
import { Globe } from "lucide-react";
import { getRoute, getRouteMatchFromPath } from "../utils/routes";

const LanguageSwitcher = ({ isScrolled = false }) => {
  const { i18n } = useTranslation();
  const location = useLocation();
  const navigate = useNavigate();

  const languages = [
    { code: "tr", label: "TR", flag: "🇹🇷" },
    { code: "en", label: "EN", flag: "🇬🇧" },
  ];

  const resolvedLang = i18n.resolvedLanguage || i18n.language;
  const currentLang = resolvedLang?.startsWith("en") ? "en" : "tr";

  const toggleLanguage = async () => {
    const newLang = currentLang === "tr" ? "en" : "tr";
    await i18n.changeLanguage(newLang);

    if (location.pathname === "/" || location.pathname === "/en") {
      navigate(newLang === "en" ? "/en" : "/");
      return;
    }

    const routeMatch = getRouteMatchFromPath(location.pathname);
    if (routeMatch?.key) {
      const newPath = getRoute(routeMatch.key, newLang, routeMatch.params);
      navigate(newPath);
    }
  };

  return (
    <button
      onClick={toggleLanguage}
      className={`flex items-center gap-1.5 px-3 py-1.5 rounded-full text-sm font-medium transition-all duration-300 ${
        isScrolled
          ? "bg-gray-100 text-gray-700 hover:bg-gray-200"
          : "bg-white/10 text-white hover:bg-white/20"
      }`}
    >
      <Globe className="w-4 h-4" />
      <span>{currentLang.toUpperCase()}</span>
    </button>
  );
};

export default LanguageSwitcher;
